import { render, staticRenderFns } from "./ParcelFigure.vue?vue&type=template&id=661f063c&"
import script from "./ParcelFigure.vue?vue&type=script&lang=js&"
export * from "./ParcelFigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports